// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');

//         this.variantIdInput.disabled = false;

//         this.form.addEventListener(
//           'submit',
//           this.onSubmitHandler.bind(this)
//         );

//         /*
//          * Keep cart-notification available because Dawn
//          * uses it to determine which sections are returned.
//          *
//          * We do NOT open or redirect to it.
//          */
//         this.cart =
//           document.querySelector('cart-notification') ||
//           document.querySelector('cart-drawer');

//         this.submitButton =
//           this.querySelector('[type="submit"]');

//         this.submitButtonText =
//           this.submitButton.querySelector('span');

//         this.hideErrors =
//           this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();

//         /*
//          * Prevent double click
//          */
//         if (
//           this.submitButton.getAttribute(
//             'aria-disabled'
//           ) === 'true'
//         ) {
//           return;
//         }

//         this.handleErrorMessage();

//         this.error = false;

//         /*
//          * Loading state
//          */
//         this.submitButton.setAttribute(
//           'aria-disabled',
//           true
//         );

//         this.submitButton.classList.add('loading');

//         const spinner =
//           this.querySelector('.loading__spinner');

//         if (spinner) {
//           spinner.classList.remove('hidden');
//         }

//         /*
//          * Shopify AJAX configuration
//          */
//         const config = fetchConfig('javascript');

//         config.headers['X-Requested-With'] =
//           'XMLHttpRequest';

//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);

//         /*
//          * We still request Dawn's cart sections,
//          * but we don't open the cart drawer.
//          */
//         if (this.cart) {
//           try {
//             const sections =
//               this.cart
//                 .getSectionsToRender()
//                 .map((section) => section.id);

//             if (sections.length) {
//               formData.append(
//                 'sections',
//                 sections
//               );

//               formData.append(
//                 'sections_url',
//                 window.location.pathname
//               );
//             }

//             this.cart.setActiveElement(
//               document.activeElement
//             );

//           } catch (error) {
//             console.warn(
//               'Cart sections could not be prepared:',
//               error
//             );
//           }
//         }

//         config.body = formData;

//         /*
//          * ==========================================
//          * ADD PRODUCT TO CART
//          * ==========================================
//          */

//         fetch(
//           `${routes.cart_add_url}`,
//           config
//         )

//           .then((response) => {

//             if (!response.ok) {
//               throw new Error(
//                 `HTTP error ${response.status}`
//               );
//             }

//             return response.json();

//           })

//           .then((response) => {

//             /*
//              * ======================================
//              * CART ERROR
//              * ======================================
//              */

//             if (response.status) {

//               this.error = true;

//               publish(
//                 PUB_SUB_EVENTS.cartError,
//                 {
//                   source: 'product-form',

//                   productVariantId:
//                     formData.get('id'),

//                   errors:
//                     response.errors ||
//                     response.description,

//                   message:
//                     response.message,
//                 }
//               );

//               this.handleErrorMessage(
//                 response.description
//               );

//               const soldOutMessage =
//                 this.submitButton.querySelector(
//                   '.sold-out-message'
//                 );

//               if (soldOutMessage) {

//                 this.submitButton.setAttribute(
//                   'aria-disabled',
//                   true
//                 );

//                 if (this.submitButtonText) {
//                   this.submitButtonText.classList.add(
//                     'hidden'
//                   );
//                 }

//                 soldOutMessage.classList.remove(
//                   'hidden'
//                 );
//               }

//               return;
//             }


//             /*
//              * ======================================
//              * SUCCESS
//              * ======================================
//              */

//             this.error = false;


//             /*
//              * Tell Dawn that cart was updated.
//              */
//             publish(
//               PUB_SUB_EVENTS.cartUpdate,
//               {
//                 source: 'product-form',

//                 productVariantId:
//                   formData.get('id'),

//                 cartData: response,
//               }
//             );


//             /*
//              * ======================================
//              * UPDATE CART COUNT
//              * ======================================
//              *
//              * We get the actual cart from Shopify.
//              * This prevents the existing number from
//              * disappearing.
//              */

//             this.updateCartCount();


//             /*
//              * ======================================
//              * SHOW SUCCESS MESSAGE
//              * ======================================
//              */

//             window.location.href = window.routes.cart_url;


//             /*
//              * ======================================
//              * IMPORTANT
//              * ======================================
//              *
//              * We intentionally DO NOT call:
//              *
//              * this.cart.renderContents(response)
//              *
//              * because you don't want the cart drawer
//              * or cart notification to open.
//              *
//              * We also do NOT redirect to /cart.
//              */

//           })

//           .catch((error) => {

//             console.error(
//               'Add to cart error:',
//               error
//             );

//             this.error = true;

//             this.handleErrorMessage(
//               'Unable to add this product to cart. Please try again.'
//             );

//           })

//           .finally(() => {

//             /*
//              * Remove loading state
//              */
//             this.submitButton.classList.remove(
//               'loading'
//             );

//             /*
//              * Re-enable button
//              */
//             if (!this.error) {

//               this.submitButton.removeAttribute(
//                 'aria-disabled'
//               );

//             }

//             /*
//              * Hide spinner
//              */
//             const spinner =
//               this.querySelector(
//                 '.loading__spinner'
//               );

//             if (spinner) {
//               spinner.classList.add('hidden');
//             }

//             /*
//              * Performance tracking
//              */
//             if (
//               typeof CartPerformance !==
//               'undefined'
//             ) {
//               CartPerformance.measureFromEvent(
//                 'add:user-action',
//                 evt
//               );
//             }

//           });
//       }


//       /*
//        * ==========================================
//        * UPDATE CART COUNT
//        * ==========================================
//        */

//       updateCartCount() {

//         fetch('/cart.js', {
//           headers: {
//             'Accept': 'application/json'
//           }
//         })

//           .then((response) => {

//             if (!response.ok) {
//               throw new Error(
//                 'Unable to fetch cart'
//               );
//             }

//             return response.json();

//           })

//           .then((cart) => {

//             const count = cart.item_count;

//             /*
//              * ----------------------------------------
//              * 1. Update every .cart-count-bubble
//              *    (handles themes with multiple bubbles,
//              *    e.g. desktop + mobile headers).
//              *
//              *    header.liquid now always renders the
//              *    bubble in the DOM (hidden when empty),
//              *    so querySelectorAll will always find it.
//              * ----------------------------------------
//              */
//             document
//               .querySelectorAll('.cart-count-bubble')
//               .forEach((bubble) => {

//                 /*
//                  * Prefer the stable #cart-count-number
//                  * span we added, fall back to spans[0]
//                  * for any other bubble instances.
//                  */
//                 const numSpan =
//                   bubble.querySelector('#cart-count-number') ||
//                   bubble.querySelector('[aria-hidden="true"]') ||
//                   bubble.querySelectorAll('span')[0];

//                 if (numSpan) {
//                   numSpan.textContent = count;
//                 }

//                 /*
//                  * Update the visually-hidden accessible
//                  * label (screen-reader cart count text).
//                  */
//                 const srSpan =
//                   bubble.querySelector('#cart-count-text') ||
//                   bubble.querySelector('.visually-hidden');

//                 if (srSpan && window.Shopify) {
//                   /*
//                    * Best-effort: update with raw count.
//                    * The full translated string would need
//                    * a Liquid re-render.
//                    */
//                   srSpan.textContent = count + ' items';
//                 }

//                 /*
//                  * Show the bubble when there are items;
//                  * hide it again if the cart is somehow 0.
//                  */
//                 if (count > 0) {
//                   bubble.classList.remove('hidden');
//                 } else {
//                   bubble.classList.add('hidden');
//                 }

//               });

//             /*
//              * ----------------------------------------
//              * 2. Swap the cart SVG icon
//              *    (empty ↔ filled) without a page reload.
//              *
//              *    header.liquid now always renders both
//              *    icon spans with js-cart-icon-empty /
//              *    js-cart-icon-full and toggles `hidden`.
//              * ----------------------------------------
//              */
//             const iconEmpty =
//               document.querySelector('.js-cart-icon-empty');

//             const iconFull =
//               document.querySelector('.js-cart-icon-full');

//             if (iconEmpty && iconFull) {
//               if (count > 0) {
//                 iconEmpty.classList.add('hidden');
//                 iconFull.classList.remove('hidden');
//               } else {
//                 iconEmpty.classList.remove('hidden');
//                 iconFull.classList.add('hidden');
//               }
//             }

//           })

//           .catch((error) => {

//             console.error(
//               'Cart count update failed:',
//               error
//             );

//           });
//       }


//       /*
//        * ==========================================
//        * SUCCESS POPUP
//        * ==========================================
//        */

//       showSuccessMessage() {

//         const toast =
//           document.getElementById(
//             'cart-success-message'
//           );

//         if (!toast) {
//           console.warn(
//             'cart-success-message not found'
//           );

//           return;
//         }


//         /*
//          * Show popup
//          */
//         toast.classList.add(
//           'active'
//         );


//         /*
//          * Clear previous timer
//          */
//         clearTimeout(
//           window.cartToastTimer
//         );


//         /*
//          * Hide after 2 seconds
//          */
//         window.cartToastTimer =
//           setTimeout(() => {

//             toast.classList.remove(
//               'active'
//             );

//           }, 2000);
//       }


//       /*
//        * ==========================================
//        * ERROR MESSAGE
//        * ==========================================
//        */

//       handleErrorMessage(
//         errorMessage = false
//       ) {

//         if (this.hideErrors) {
//           return;
//         }

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(
//             '.product-form__error-message-wrapper'
//           );

//         if (!this.errorMessageWrapper) {
//           return;
//         }

//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             '.product-form__error-message'
//           );

//         this.errorMessageWrapper.toggleAttribute(
//           'hidden',
//           !errorMessage
//         );

//         if (errorMessage) {

//           this.errorMessage.textContent =
//             errorMessage;

//         }

//       }


//       /*
//        * ==========================================
//        * TOGGLE SUBMIT BUTTON
//        * ==========================================
//        */

//       toggleSubmitButton(
//         disable = true,
//         text
//       ) {

//         if (disable) {

//           this.submitButton.setAttribute(
//             'disabled',
//             'disabled'
//           );

//           if (text) {

//             this.submitButtonText.textContent =
//               text;

//           }

//         } else {

//           this.submitButton.removeAttribute(
//             'disabled'
//           );

//           this.submitButtonText.textContent =
//             window.variantStrings.addToCart;

//         }

//       }


//       /*
//        * ==========================================
//        * VARIANT ID
//        * ==========================================
//        */

//       get variantIdInput() {

//         return this.form.querySelector(
//           '[name=id]'
//         );

//       }

//     }
//   );
// }


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        /*
         * cart-drawer or cart-notification, depending on
         * the theme's "Cart type" setting. Null when the
         * cart type is "page".
         */
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        /*
         * Prevent double click
         */
        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;

        /*
         * Loading state
         */
        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        /*
         * Shopify AJAX configuration
         */
        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        /*
         * Request Dawn's cart sections so the
         * drawer / notification can be re-rendered.
         */
        if (this.cart) {
          try {
            const sections =
              this.cart
                .getSectionsToRender()
                .map((section) => section.id);

            if (sections.length) {
              formData.append(
                'sections',
                sections
              );

              formData.append(
                'sections_url',
                window.location.pathname
              );
            }

            this.cart.setActiveElement(
              document.activeElement
            );

          } catch (error) {
            console.warn(
              'Cart sections could not be prepared:',
              error
            );
          }
        }

        config.body = formData;

        /*
         * ==========================================
         * ADD PRODUCT TO CART
         * ==========================================
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )

          .then((response) => {

            if (!response.ok) {
              throw new Error(
                `HTTP error ${response.status}`
              );
            }

            return response.json();

          })

          .then((response) => {

            /*
             * ======================================
             * CART ERROR
             * ======================================
             */

            if (response.status) {

              this.error = true;

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {

                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                if (this.submitButtonText) {
                  this.submitButtonText.classList.add(
                    'hidden'
                  );
                }

                soldOutMessage.classList.remove(
                  'hidden'
                );
              }

              return;
            }


            /*
             * ======================================
             * SUCCESS
             * ======================================
             */

            this.error = false;


            /*
             * Tell Dawn that cart was updated.
             */
            publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                cartData: response,
              }
            );


            /*
             * ======================================
             * UPDATE CART COUNT
             * ======================================
             *
             * We get the actual cart from Shopify.
             * This prevents the existing number from
             * disappearing.
             */

            this.updateCartCount();


            /*
             * ======================================
             * OPEN CART (drawer / notification / page)
             * ======================================
             *
             * Respect the theme setting "Cart type":
             * - drawer / notification -> render & open it
             * - page (no cart element) -> go to /cart
             */

            if (!this.cart) {
              window.location.href = window.routes.cart_url;
              return;
            }

            if (this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

          })

          .catch((error) => {

            console.error(
              'Add to cart error:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              'Unable to add this product to cart. Please try again.'
            );

          })

          .finally(() => {

            /*
             * Remove loading state
             */
            this.submitButton.classList.remove(
              'loading'
            );

            /*
             * Re-enable button
             */
            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );

            }

            /*
             * Hide spinner
             */
            const spinner =
              this.querySelector(
                '.loading__spinner'
              );

            if (spinner) {
              spinner.classList.add('hidden');
            }

            /*
             * Performance tracking
             */
            if (
              typeof CartPerformance !==
              'undefined'
            ) {
              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );
            }

          });
      }


      /*
       * ==========================================
       * UPDATE CART COUNT
       * ==========================================
       */

      updateCartCount() {

        fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        })

          .then((response) => {

            if (!response.ok) {
              throw new Error(
                'Unable to fetch cart'
              );
            }

            return response.json();

          })

          .then((cart) => {

            const count = cart.item_count;

            /*
             * ----------------------------------------
             * 1. Update every .cart-count-bubble
             *    (handles themes with multiple bubbles,
             *    e.g. desktop + mobile headers).
             *
             *    header.liquid now always renders the
             *    bubble in the DOM (hidden when empty),
             *    so querySelectorAll will always find it.
             * ----------------------------------------
             */
            document
              .querySelectorAll('.cart-count-bubble')
              .forEach((bubble) => {

                /*
                 * Prefer the stable #cart-count-number
                 * span we added, fall back to spans[0]
                 * for any other bubble instances.
                 */
                const numSpan =
                  bubble.querySelector('#cart-count-number') ||
                  bubble.querySelector('[aria-hidden="true"]') ||
                  bubble.querySelectorAll('span')[0];

                if (numSpan) {
                  numSpan.textContent = count;
                }

                /*
                 * Update the visually-hidden accessible
                 * label (screen-reader cart count text).
                 */
                const srSpan =
                  bubble.querySelector('#cart-count-text') ||
                  bubble.querySelector('.visually-hidden');

                if (srSpan && window.Shopify) {
                  /*
                   * Best-effort: update with raw count.
                   * The full translated string would need
                   * a Liquid re-render.
                   */
                  srSpan.textContent = count + ' items';
                }

                /*
                 * Show the bubble when there are items;
                 * hide it again if the cart is somehow 0.
                 */
                if (count > 0) {
                  bubble.classList.remove('hidden');
                } else {
                  bubble.classList.add('hidden');
                }

              });

            /*
             * ----------------------------------------
             * 2. Swap the cart SVG icon
             *    (empty ↔ filled) without a page reload.
             *
             *    header.liquid now always renders both
             *    icon spans with js-cart-icon-empty /
             *    js-cart-icon-full and toggles `hidden`.
             * ----------------------------------------
             */
            const iconEmpty =
              document.querySelector('.js-cart-icon-empty');

            const iconFull =
              document.querySelector('.js-cart-icon-full');

            if (iconEmpty && iconFull) {
              if (count > 0) {
                iconEmpty.classList.add('hidden');
                iconFull.classList.remove('hidden');
              } else {
                iconEmpty.classList.remove('hidden');
                iconFull.classList.add('hidden');
              }
            }

          })

          .catch((error) => {

            console.error(
              'Cart count update failed:',
              error
            );

          });
      }


      /*
       * ==========================================
       * SUCCESS POPUP
       * ==========================================
       */

      showSuccessMessage() {

        const toast =
          document.getElementById(
            'cart-success-message'
          );

        if (!toast) {
          console.warn(
            'cart-success-message not found'
          );

          return;
        }


        /*
         * Show popup
         */
        toast.classList.add(
          'active'
        );


        /*
         * Clear previous timer
         */
        clearTimeout(
          window.cartToastTimer
        );


        /*
         * Hide after 2 seconds
         */
        window.cartToastTimer =
          setTimeout(() => {

            toast.classList.remove(
              'active'
            );

          }, 2000);
      }


      /*
       * ==========================================
       * ERROR MESSAGE
       * ==========================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }

      }


      /*
       * ==========================================
       * TOGGLE SUBMIT BUTTON
       * ==========================================
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {

            this.submitButtonText.textContent =
              text;

          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;

        }

      }


      /*
       * ==========================================
       * VARIANT ID
       * ==========================================
       */

      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }

    }
  );
}